import styled from 'styled-components';
import { ReactComponent as RetrySvg } from '../../../images/errores/retry.svg';

const ContainerStyled = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 360px;
  padding: 32px 40px;
  margin: 0 auto;
`;

const RetrySvgStyled = styled(RetrySvg)`
  margin: 6px auto 24px;

  @media (min-width: 769px) {
    margin: 20px auto 24px;
  }
`;

const TitleStyled = styled.h2`
  font-size: 18px;
  line-height: 22px;
  color: #0e141d;
  font-weight: bold;
  text-align: center;
`;

const MessageStyled = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: #494c66;
  text-align: center;
  padding: 8px 0 24px;

  a {
    color: #e92070;
  }
`;

const UnderlineButtonStyled = styled.button`
  margin: 0 auto;
  padding: 8px 0 0;
  background: none;
  border: none;
  color: #e92070;
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;
`;

export {
  ContainerStyled,
  RetrySvgStyled,
  TitleStyled,
  MessageStyled,
  UnderlineButtonStyled,
};
